import React from 'react';

interface SpinnerPopUpProps {
  visible?: boolean;
}

const SpinnerPopUp: React.FC<SpinnerPopUpProps> = ({ visible = false }) => {

  if (!visible) return null;
  return (
    <div className="loaderWrapper">
      <div className="spinner-dualball">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default SpinnerPopUp;